import { GetCurrentUserQuery } from '@/Types/gql/graphql';
import { makeVar } from '@apollo/client';

export type AuthType = {
  loading: boolean;
  authenticated: boolean;
  userDetails?: undefined | null | GetCurrentUserQuery['getCurrentUser'];
};

export const authState = makeVar<AuthType>({
  loading: true,
  authenticated: false,
});
